import makeStyles from '@mui/styles/makeStyles';
import { type Theme } from '@mui/material';
import colors from '../../styles/colors';

interface StylesProps {
  expanded: boolean;
  accordionHeight: number;
}

export const useStyles = makeStyles((theme: Theme) => ({
  accordion: {
    height: ({ accordionHeight }: StylesProps) => {
      return `${accordionHeight}px`;
    },
    overflowY: 'hidden',
    paddingLeft: '4px',
    paddingRight: '4px',
    '&, & *': {
      transition: 'all 300ms ease',
    },
    '&:nth-child(n+2)': {
      borderTop: `1px solid ${colors.gray.l85}`,
    },
    [theme.breakpoints.down(600)]: {
      paddingLeft: '0px',
    },
  },
  accordionSummary: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    columnGap: '12px',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  summary: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    marginTop: '16px',
    marginBottom: '16px',
    [theme.breakpoints.down(600)]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  expandMoreIcon: {
    transform: ({ expanded }: StylesProps) => {
      return expanded ? 'rotate(0)' : 'rotate(-0.25turn)';
    },
  },
  accordionDetails: {
    marginTop: ({ expanded }: StylesProps) => {
      return expanded ? '-12px' : '0px';
    },
  },
  details: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
}));
